import React, { useMemo } from "react"
import { Button } from "@material-ui/core"
import ImportExportIcon from "@material-ui/icons/ImportExport"
import * as FileSaver from "file-saver"
import { openSnackBar } from "../../../../actions/snack-bar"
import { useDispatch } from "react-redux"
import { Parser } from "json2csv"
import { Typography } from "../../../../../node_modules/@material-ui/core/index"
import markUpCalc from "../../../../utils/markUpCalc"
import PropTypes from "prop-types"

const ExportButton = ({ allExpenses = [] }) => {
  const dispatch = useDispatch()

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  let expensesToBeExported = useMemo(
    () => {
      let onlyExpenses = []
      allExpenses.map(role =>
        role.expenses.map(expense => {
          let expenseData = {
            position_name: role.name,
            item_type: expense.item_type,
            name: expense.type_name,
            quantity: expense.quantity,
            actual_rate: expense.actual_rate,
            client_rate: expense.is_percentage
              ? markUpCalc(
                expense.quantity * expense.actual_rate,
                expense.client_rate
              )
              : expense.client_rate,
            discount: expense.discount,
            expense_id: expense.expense_id,
            description: expense.description,
          }
          onlyExpenses = [...onlyExpenses, expenseData]
          return onlyExpenses
        })
      )
      return onlyExpenses
    },
    [allExpenses]
  )

  function exportFile() {
    const fields = [
      "position_name",
      "item_type",
      "name",
      "quantity",
      "actual_rate",
      "client_rate",
      "discount",
      "description",
    ]
    const opts = { fields }
    try {
      const parser = new Parser(opts)
      const csv = parser.parse(expensesToBeExported)
      var file = new Blob([csv], { type: "text/csv" })
      FileSaver.saveAs(file, `ExpenseInvoice.csv`)
    } catch (err) {
      dispatch(openSnackBar({ message: "Error downloading expense data" }))
    }
  }

  return (
    <Button onClick={exportFile}>
      <ImportExportIcon
        style={viewportWidth > 600 ? {} : { fontSize: "20px" }}
      />
      <Typography
        style={
          viewportWidth > 600
            ? { fontSize: "18px", fontWeight: 550 }
            : { fontSize: "15px", fontWeight: 550 }
        }
      >
        Export All
      </Typography>
    </Button>
  )
}

ExportButton.propType = {
  allExpenses: PropTypes.array,
}

export default ExportButton
